import { motion } from 'framer-motion';
const Skills = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className='w-full flex flex-col lgl:flex-row lgl:gap-20 gap-10 px-5'
    >
      <div className='lgl:w-1/2 w-full'>
        <div className='py-12 font-titleFont'>
          <p className='text-sm text-designColor tracking-[4px]'> Features</p>
          <h2 className='text-3xl md:text-4xl font-bold'>DESIGN SKILLS</h2>
        </div>
        <div className='w-full mt-5 flex flex-col gap-5'>
          <div className='overflow-x-hidden'>
            <p className='text-sm uppercase font-medium'>Photoshot</p>
            <span className='bg-black bg-opacity-40 w-full h-2 inline-flex rounded-md mt-2 relative'>
              <motion.span
                initial={{ x: '-90%', opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className='w-[90%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative'
              >
                <span className='absolute -top-7  right-0'>90%</span>
              </motion.span>
            </span>
          </div>
          <div className='overflow-x-hidden'>
            <p className='text-sm uppercase font-medium'>Adobe Premier</p>
            <span className='bg-black bg-opacity-40 w-full h-2 inline-flex rounded-md mt-2 relative'>
              <motion.span
                initial={{ x: '-100%', opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className='w-[100%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative'
              >
                <span className='absolute -top-7  right-0'>100%</span>
              </motion.span>
            </span>
          </div>
          <div className='overflow-x-hidden'>
            <p className='text-sm uppercase font-medium'>Corel Draw</p>
            <span className='bg-black bg-opacity-40 w-full h-2 inline-flex rounded-md mt-2 relative'>
              <motion.span
                initial={{ x: '-90%', opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className='w-[90%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative'
              >
                <span className='absolute -top-7  right-0'>90%</span>
              </motion.span>
            </span>
          </div>
          <div className='overflow-x-hidden'>
            <p className='text-sm uppercase font-medium'>Figma</p>
            <span className='bg-black bg-opacity-40 w-full h-2 inline-flex rounded-md mt-2 relative'>
              <motion.span
                initial={{ x: '-70%', opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className='w-[70%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative'
              >
                <span className='absolute -top-7  right-0'>70%</span>
              </motion.span>
            </span>
          </div>
          <div className='overflow-x-hidden'>
            <p className='text-sm uppercase font-medium'>Android Studio</p>
            <span className='bg-black bg-opacity-40 w-full h-2 inline-flex rounded-md mt-2 relative'>
              <motion.span
                initial={{ x: '-80%', opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className='w-[80%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative'
              >
                <span className='absolute -top-7  right-0'>80%</span>
              </motion.span>
            </span>
          </div>
          <div className='overflow-x-hidden'>
            <p className='text-sm uppercase font-medium'>Canva</p>
            <span className='bg-black bg-opacity-40 w-full h-2 inline-flex rounded-md mt-2 relative'>
              <motion.span
                initial={{ x: '-100%', opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className='w-full h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative'
              >
                <span className='absolute -top-7  right-0'>100%</span>
              </motion.span>
            </span>
          </div>
        </div>
      </div>
      <div className='lgl:w-1/2 w-full'>
        <div className='py-12 font-titleFont'>
          <p className='text-sm text-designColor tracking-[4px]'> Features</p>
          <h2 className='text-3xl md:text-4xl font-bold'>DEVELOPMENT SKILLS</h2>
        </div>
        <div className='w-full mt-5 flex flex-col gap-5 '>
          <div className='overflow-x-hidden'>
            <p className='text-sm uppercase font-medium'>Microsoft Office</p>
            <span className='bg-black bg-opacity-40 w-full h-2 inline-flex rounded-md mt-2 relative'>
              <motion.span
                initial={{ x: '-100%', opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className='w-[100%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative'
              >
                <span className='absolute -top-7  right-0'>100%</span>
              </motion.span>
            </span>
          </div>
          <div className='overflow-x-hidden'>
            <p className='text-sm uppercase font-medium'>HTML 5</p>
            <span className='bg-black bg-opacity-40 w-full h-2 inline-flex rounded-md mt-2 relative'>
              <motion.span
                initial={{ x: '-100%', opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className='w-full h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative'
              >
                <span className='absolute -top-7  right-0'>100%</span>
              </motion.span>
            </span>
          </div>
          <div className='overflow-x-hidden'>
            <p className='text-sm uppercase font-medium'>CSS3</p>
            <span className='bg-black bg-opacity-40 w-full h-2 inline-flex rounded-md mt-2 relative'>
              <motion.span
                initial={{ x: '-90%', opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className='w-[90%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative'
              >
                <span className='absolute -top-7  right-0'>90%</span>
              </motion.span>
            </span>
          </div>
          <div className='overflow-x-hidden'>
            <p className='text-sm uppercase font-medium'>Java</p>
            <span className='bg-black bg-opacity-40 w-full h-2 inline-flex rounded-md mt-2 relative'>
              <motion.span
                initial={{ x: '-70%', opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className='w-[70%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative'
              >
                <span className='absolute -top-7  right-0'>70%</span>
              </motion.span>
            </span>
          </div>
          <div className='overflow-x-hidden'>
            <p className='text-sm uppercase font-medium'>Javascript</p>
            <span className='bg-black bg-opacity-40 w-full h-2 inline-flex rounded-md mt-2 relative'>
              <motion.span
                initial={{ x: '-90%', opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className='w-[90%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative'
              >
                <span className='absolute -top-7  right-0'>90%</span>
              </motion.span>
            </span>
          </div>
          <div className='overflow-x-hidden'>
            <p className='text-sm uppercase font-medium'>React</p>
            <span className='bg-black bg-opacity-40 w-full h-2 inline-flex rounded-md mt-2 relative'>
              <motion.span
                initial={{ x: '-80%', opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className='w-[80%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative'
              >
                <span className='absolute -top-7  right-0'>80%</span>
              </motion.span>
            </span>
          </div>

            <div className='overflow-x-hidden'>
            <p className='text-sm uppercase font-medium'>Flask</p>
            <span className='bg-black bg-opacity-40 w-full h-2 inline-flex rounded-md mt-2 relative'>
              <motion.span
                initial={{ x: '-90%', opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className='w-[90%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative'
              >
                <span className='absolute -top-7  right-0'>90%</span>
              </motion.span>
            </span>
          </div>
            <div className='overflow-x-hidden'>
            <p className='text-sm uppercase font-medium'>Node js</p>
            <span className='bg-black bg-opacity-40 w-full h-2 inline-flex rounded-md mt-2 relative'>
              <motion.span
                initial={{ x: '-80%', opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                className='w-[80%] h-full bg-gradient-to-r from-blue-600 via-pink-500 to-red-500 rounded-md relative'
              >
                <span className='absolute -top-7  right-0'>80%</span>
              </motion.span>
            </span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
export default Skills;
